import { T, F } from './tokens';

interface PassGaugeProps {
  score: number;
  size?: number;
  color?: string;
}

export function PassGauge({ score, size = 100, color }: PassGaugeProps) {
  const c = color || (score >= 70 ? T.success : score >= 50 ? T.warning : T.danger);
  const circumference = Math.PI * (size - 12);
  const offset = circumference - (score / 100) * circumference;

  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={{ transform: 'rotate(-90deg)' }}
      >
        <circle
          cx={size / 2} cy={size / 2} r={(size - 12) / 2}
          fill="none" stroke={T.bgInput} strokeWidth="6"
        />
        <circle
          cx={size / 2} cy={size / 2} r={(size - 12) / 2}
          fill="none" stroke={c} strokeWidth="6"
          strokeDasharray={circumference} strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 1s ease-out' }}
        />
      </svg>
      <div style={{
        position: 'absolute', inset: 0,
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
      }}>
        <span style={{
          fontSize: size * 0.3, fontFamily: F.mono,
          fontWeight: 700, color: c,
        }}>
          {score}
        </span>
        <span style={{ fontSize: 9, color: T.textGhost, fontFamily: F.mono }}>%</span>
      </div>
    </div>
  );
}
